import { useEffect, useState, useRef } from 'react';
import { Flex } from '../../../component-library';
import { VideoChat } from '../../../components';
import { useReceiveMessage, usePostMessage } from '../../../context/messageContext';
import { useCalibration } from '../../../context/calibrationContext';
import { useToolDetection } from '../../../helpers/distance-detection-hooks';
import { calibrationConstants } from '../../../helpers/calibration-constants';
import { ReactComponent as Refractotype } from '../../../assets/refraction/refractotype1.svg';

const ResponsiveRefractionTwoTestPatient = () => {
  const positionImages = {
    1: <Refractotype />,
    2: <Refractotype style={{ transform: 'rotate(60deg)' }} />,
    3: <Refractotype style={{ transform: 'rotate(-60deg)' }} />,
  };
  const {
    calibrationData: { perceivedFocalLength },
  } = useCalibration();
  const messageFromOptician = useReceiveMessage();
  const postMessage = usePostMessage();

  const [stimulusSize, setStimulusSize] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState(1);
  const [visibleStimulus, setVisibleStimulus] = useState(false);
  const [pixelDensity, setPixelDensity] = useState(0);

  const canvasDOM = useRef(null);
  const videoDOM = useRef(null);
  const { setShouldCollectToolDistance, toolDistance } = useToolDetection({
    videoDOM,
    canvasDOM,
    perceivedFocalLength: perceivedFocalLength ? perceivedFocalLength : calibrationConstants.perceivedFocalLength,
  });

  const videoChatCustomStyle = {
    videoBox: {
      position: 'fixed',
      top: 0,
      left: 0,
      visibility: '',
      width: 100,
      height: 100,
      overflow: 'hidden',
    },
    localParticipant: {
      overflow: 'hidden',
    },
  };

  const updateTarget = (newTarget) => {
    setSelectedPosition(newTarget.stimulusPosition);
    setStimulusSize(newTarget.stimulusSize);
    setVisibleStimulus(newTarget.visibleStimulus);
    setPixelDensity(newTarget.pixelDensity);
  };

  const getTarget = () => {
    const stimulusSizeInPx = pixelDensity ? Math.round(stimulusSize / pixelDensity) : 0;
    const targetStyle = {
      width: Math.ceil(stimulusSizeInPx),
      height: Math.ceil(stimulusSizeInPx),

      position: 'absolute',
      borderRadius: Math.round(stimulusSizeInPx / 2),
      top: pixelDensity ? 25 / pixelDensity : 0,
      left: window.screen.width / 2 - Math.round(stimulusSizeInPx / 2),
      display: visibleStimulus === true ? 'block' : 'none',
    };

    return <Flex style={{ ...targetStyle, backgroundColor: 'transparent' }}>{positionImages[selectedPosition]}</Flex>;
  };

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'updateTarget':
        updateTarget(messageFromOptician.content);
        break;
      case 'detectDistance':
        setShouldCollectToolDistance(true);
        break;
      case 'stopDetections':
        setShouldCollectToolDistance(false);
        break;
      default:
        break;
    }
  }, [messageFromOptician, setShouldCollectToolDistance]);

  useEffect(() => {
    postMessage({ type: 'patientDistance', content: toolDistance });
  }, [postMessage, toolDistance]);

  return (
    <Flex>
      <VideoChat stacked customStyle={videoChatCustomStyle} parentVideoRef={videoDOM} />
      <Flex width='100vw' height='100vh' overflow='hidden' justifyContent='center' bg='black' style={{ zIndex: 9 }}>
        <canvas id='canvas' style={{ display: 'none' }} ref={canvasDOM}></canvas>
        {getTarget()}
      </Flex>
    </Flex>
  );
};

export default ResponsiveRefractionTwoTestPatient;
